/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'
import {merge} from'../utils/uiUtils'
export default class Text extends PureComponent {

    getElm(){
        return this.refs.raw
    }

    render() {
        const {style, center, ...other} = this.props;
        const newStyle = {
            display: 'inline-block'
        };

        if (center) {
            newStyle.textAlign = 'center';
        }

        return <div style={merge(newStyle, style)} {...other}/>
    }
}


// WEBPACK FOOTER //
// ./src/components/Text.js